import config from './webIMConfig'
import { browser } from './function'
import websdk from 'easemob-websdk'

// 初始化IM SDK
var WebIM = {}
WebIM = window.WebIM = websdk
WebIM.config = config

var initChat = function() {
  WebIM.conn = new WebIM.connection({
    appKey: WebIM.config.appkey,
    isHttpDNS: WebIM.config.isHttpDNS,
    isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
    https: WebIM.config.https,
    url: WebIM.config.xmppURL,
    apiUrl: WebIM.config.apiURL,
    isAutoLogin: true,
    heartBeatWait: WebIM.config.heartBeatWait,
    autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
    autoReconnectInterval: WebIM.config.autoReconnectInterval,
    isStropheLog: WebIM.config.isStropheLog,
    delivery: WebIM.config.delivery
  })
  if (!WebIM.conn.apiUrl) {
    WebIM.conn.apiUrl = WebIM.config.apiURL
  }
}

initChat()

var notification = function(message) {
  let _this = window.vm
  const h = _this.$createElement
  if (_this.$store.state.receivingUser !== message.from.toUpperCase() && _this.$route.name !== 'Chat') {
    _this.$notify({
      title: _this.$t('You have a new message'),
      duration: 2000,
      message: h(
        'div',
        {
          attrs: {
            class: 'notification-link'
          },
          on: {
            click: () => {
              _this.$router.push('/chat')
            }
          }
        },
        _this.$t('Click to check')
      )
    })
    _this.$store.commit('setNewMessageStatus', true)
  }
}

// 注册监听回调
WebIM.conn.listen({
  // 连接成功回调
  onOpened: () => {
    const imAccount = window.vm.$store.getters.imAccount
    let role = ''
    if(imAccount.name && imAccount.name === '游客') {
      role = 'tourist'
    }
    window.vm.$store.commit('setChatRole', role)
    window.vm.$store.commit('setSendingUser', window.vm.$store.getters.imAccount.easemobAccount)
    window.vm.$store.dispatch('changeChatConnectStatus', true)
    // 连接成功后，将本地聊天记录同步到store
    // const localMsgData = localStorage.getItem(`allChatData__${window.vm.$store.getters.imAccount.easemobAccount}`)
    // if (localMsgData) {
    //   window.vm.$store.commit('syncChatMsg', JSON.parse(localMsgData))
    // }
    // 为会话列表的每个人填充20条数据
    window.vm.$store.dispatch('fetchChatMsg')
  },

  // 连接关闭回调
  onClosed: function() {
    window.vm.$store.dispatch('changeChatConnectStatus', false)
  },

  // 收到文本消息
  onTextMessage: message => {
    // console.log(message)
    let _this = window.vm
    notification(message)
    if(!message.ext.easemobAccount) {
      message.ext.easemobAccount = message.from
      message.ext.name = message.ext.extendUserNickName
      message.ext.avatar = message.ext.extendUserAvatar
    }
    _this.$store.commit('setChatList', {
      chatType: 'singleChat',
      chatId: message.from,
      msg: message.data,
      bySelf: false,
      time: message.time,
      mid: message.id,
      status: 'sending',
      ext: message.ext
    })
  },
  onEmojiMessage: function() {}, // 收到表情消息
  // 收到图片消息
  onPictureMessage: message => {
    let _this = window.vm
    notification(message)
    if(!message.ext.easemobAccount) {
      message.ext.easemobAccount = message.from
      message.ext.name = message.ext.extendUserNickName
      message.ext.avatar = message.ext.extendUserAvatar
    }
    _this.$store.commit('setChatList', {
      chatType: 'singleChat',
      chatId: message.from,
      msg: message.url,
      bySelf: false,
      type: 'img',
      from: message.from,
      ext: message.ext
    })
  },
  onCmdMessage: function() {}, // 收到命令消息
  // 收到音频消息
  onAudioMessage: message => {
    // console.log(message)
    let _this = window.vm
    notification(message)
    let options = {
      url: message.url,
      headers: { Accept: 'audio/mp3' },
      onFileDownloadComplete: response => {
        let objectUrl = WebIM.utils.parseDownloadResponse.call(WebIM.conn, response)
        // sycn ext from app
        if(!message.ext.easemobAccount) {
          message.ext.easemobAccount = message.from
          message.ext.name = message.ext.extendUserNickName
          message.ext.avatar = message.ext.extendUserAvatar
        }
        _this.$store.commit('setChatList', {
          chatType: 'singleChat',
          chatId: message.from,
          msg: objectUrl,
          audioURL: message.url,
          bySelf: false,
          type: 'audio',
          from: message.from,
          ext: message.ext
        })
      },
      onFileDownloadError: function() {
        // console.log("音频下载失败");
      }
    }
    WebIM.utils.download.call(WebIM.conn, options)
  },
  onLocationMessage: function() {}, // 收到位置消息
  // 收到文件消息
  onFileMessage: message => {
    let _this = window.vm
    notification(message)
    if(!message.ext.easemobAccount) {
      message.ext.easemobAccount = message.from
      message.ext.name = message.ext.extendUserNickName
      message.ext.avatar = message.ext.extendUserAvatar
    }
    _this.$store.commit('setChatList', {
      chatType: 'singleChat',
      chatId: message.from,
      msg: message.url,
      bySelf: false,
      type: 'file',
      filename: message.filename,
      file_length: message.file_length,
      from: message.from,
      ext: message.ext
    })
  },
  // 收到视频消息
  onVideoMessage: function() {},
  onPresence: function() {}, // 处理“广播”或“发布-订阅”消息，如联系人订阅请求、处理群组、聊天室被踢解散等消息
  onRoster: function() {}, // 处理好友申请
  onInviteMessage: function() {}, // 处理群组邀请
  onOnline: function() {
    window.vm.$store.dispatch('changeChatConnectStatus', true)
  }, // 本机网络连接成功
  // 本机网络掉线
  onOffline: () =>{
    window.vm.$store.dispatch('changeChatConnectStatus', false)
  },

  // 失败回调
  onError: message => {
    console.log(message)
    window.vm.$store.dispatch('changeChatConnectStatus', false)
    if (message.type === 16) {
      // 断线重连
      console.log('掉线')
      window.vm.$store.dispatch('chatLogout')
    }
    if (message.type === 206) {
      // 被踢
      console.log('被踢了')
    }
  },

  onBlacklistUpdate: function() {
    // 黑名单变动
    // 查询黑名单，将好友拉黑，将好友从黑名单移除都会回调这个函数，list则是黑名单现有的所有好友信息
    // console.log(list)
  },

  onRecallMessage: function() {}, // 收到撤回消息回调
  // 收到消息送达服务器回执
  onReceivedMessage: () => {},
  onDeliveredMessage: function() {}, // 收到消息送达客户端回执
  onReadMessage: function() {}, // 收到消息已读回执
  onCreateGroup: function() {}, // 创建群组成功回执（需调用createGroupNew）
  onMutedMessage: function() {} // 如果用户在A群组被禁言，在A群发消息会走这个回调并且消息不会传递给群其它成员
})
if ((browser&&!browser.trident && window.location.protocol === 'https:') || config.isDebug) {
  WebIM.WebRTC = require('easemob-webrtc')
}

export default WebIM
